import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

import { RECIPIENT_TYPE_SELF, TYPE } from '../constants/Constants';

export function useForm(formName) {
    return useSelector(({ form }) => form[formName]);
}

export function useForms() {
    return useSelector(({ form }) => form);
}

export function useLanguage() {
    return useSelector(({ language }) => language);
}

export function useFields(formName) {
    return useSelector(({ form }) => form[formName]?.fields);
}

export function usePageMessages() {
    return useSelector(({ messages }) => messages.pageMessages);
}

export function useComplexMessage() {
    return useSelector(({ messages }) => messages.complexMessages);
}

export function useJsMessages() {
    return useSelector(({ messages }) => messages.jsMessages);
}

export function useApp() {
    return useSelector(({ app }) => app);
}

export function useAuth() {
    return useSelector(({ auth }) => auth);
}

export function useExtra() {
    return useSelector(({ extra }) => extra);
}

export function useTypeOfTransfer() {
    const extra = useSelector(({ extra }) => extra);
    const [searchParams] = useSearchParams();

    return extra?.typeOfTransfer && extra.typeOfTransfer !== searchParams.get(TYPE) && searchParams.get(TYPE) !== RECIPIENT_TYPE_SELF
        ? extra.typeOfTransfer
        : searchParams.get(TYPE);
}

export function useRequest() {
    return useSelector(({ request }) => request);
}

export function useLogin() {
    return useSelector(({ login }) => login);
}

export function useHistoryRecords() {
    return useSelector(({ history }) => history?.paymentHistory);
}

export function useCheckMeta() {
    return useSelector(({ history }) => history?.cheque);
}

export function useCheck() {
    return useSelector(({ history }) => history?.cheque?.cheque);
}

export function useChequeExtra() {
    return useSelector(({ history }) => history?.cheque?.extra);
}

export function useErrors() {
    return useSelector(({ errors }) => errors);
}

export function useCalculator() {
    return useSelector(({ calculator }) => calculator);
}

export function useSend() {
    return useSelector(({ send }) => send);
}
